import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../components/ui/card";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import Table2 from "../../../components/table/table-2";
import { useEffect, useState, useMemo } from "react";
import { columns, data } from "../../../data/admin/role/create-doctor";
import FormRenderer from "../../../components/input-field/form-renderer";
import { createDoctorFields } from "../../../config/role/create-doctor";
import { isFormValid } from "../../../utils/validators";
import { Loader, Loader2, StethoscopeIcon } from "lucide-react";
import {
  changeEmployeeStatus,
  getAllEmployee,
  getEmployeeById,
  updateDoctor,
} from "../../../services/employee/employee-details-service";
import { showErrorToast, showSuccessToast } from "../../../utils/toast-utils";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ViewEmployeeDataByID from "../../../components/viewsModals/ViewEmployeeDataById";
const CreateDoctor = () => {
  const queryClient = useQueryClient();
  const [currentDoctor, setCurrentDoctor] = useState(null);
  const [form, setForm] = useState({});
  const [fee, setFee] = useState("");
  const [days, setDays] = useState([]);
  const [isSubmitloading, setIsSubmitLoading] = useState(false);

  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);
  const [isViewLoading, setIsViewLoading] = useState(false);
  const [singleEmployeeData, setSingleEmployeeData] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const role = 'doctor';
  const { data: employee = [], isLoading: employeeLoading } = useQuery({
    queryKey: ["get-all-employee", currentPage, limit, role],
    queryFn: async () => {
      return await getAllEmployee({ limit, page: currentPage, role });
    },
  });
  const employeeRows = employee?.data?.data?.rows ?? [];

  const allDoctors = useMemo(() => {
    return employeeRows.filter((item) => {
      const role = item.role?.toLowerCase();
      return role === "doctor" || role === "doctors";
    });
  }, [employee?.data?.data?.rows]);

  const weekDays = ["Monday", "Tuesday", "Wednesday", "Thursday",
    "Friday", "Saturday", "Sunday"];
  const handleSelect = (day) => {
    setDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day],
    );
  };


  const handleFeeChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setFee("");
      return;
    }

    if (/^\d+$/.test(value)) {
      setFee(value);
    }
  };

  useEffect(() => {
    if (!currentDoctor) return;

    setForm((prev) => ({
      ...prev,
      full_name: currentDoctor.name,
      mobile: currentDoctor.mobile,
      email: currentDoctor.email,
    }));
  }, [currentDoctor]);

  const validForm =
    form.opd_end_time &&
    form.opd_start_time &&
    form.specialization &&
    form.qualification;

  const handleSubmit = async () => {
    if (!validForm) {
      showErrorToast("Some fields are missing or invalid");
    }
    setIsSubmitLoading(true);

    const payload = {
      qualification: form.qualification,
      specialization: form.specialization,
      opdDays: days,
      opdStartTime: form.opd_start_time,
      opdEndTime: form.opd_end_time,
      consultationFee: fee,
    };

    try {
      const res = await updateDoctor({ id: currentDoctor.id, payload });
      
      if (
        res?.status === 200 ||
        res?.status === 201 ||
        res?.data?.status === 201
      ) {
        showSuccessToast(
          res?.data?.message ||
          res?.data?.data?.message,
        );
      } else {
        showErrorToast(
          res?.data?.message ||
          res?.data?.data?.message,
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const employeeColumns = [
    {
      key: "index",
      label: "S.No",
      render: (_, index) => index + 1,
    },
    {
      key: "employeeId",
      label: "Employee ID",
    },
    {
      key: "name",
      label: "Name",
      render: (row) => `${row.title?.toUpperCase()} ${row.name}`,
    },
    {
      key: "role",
      label: "Role",
    },
    {
      key: "mobile",
      label: "Mobile",
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "isActive",
      label: "Status",
      render: (row) => (
        <button
          onClick={() => handleStatus(row)}
          className={`rounded-full border h-[28px] w-[50px] text-xs font-semibold items-center flex transition-all duration-200 ${row.isActive
              ? "border-blue-700 bg-blue-100 justify-end"
              : "border-gray-400 bg-gray-100 justify-start"
            }`}
        >
          <span
            className={`inline-block h-[22px] w-[22px] rounded-full transition-all duration-200 ${row.isActive ? "bg-blue-700" : "bg-gray-400"
              }`}
          ></span>
        </button>
      ),
    },

    {
      key: "action",
      label: "Action",

      render: (row) => (
        <div className="flex gap-2">
          <button
            className="px-2 py-1 text-xs bg-blue-100 text-blue-600 rounded hover:bg-blue-200"
            onClick={() => handleViewEmployee(row?.id)}
          >
            View
          </button>
        </div>
      ),
    },
  ];

  const handleStatus = async (row) => {
    setIsEmployeeLoading(true);
    try {
      const res = await changeEmployeeStatus({
        id: row.id,
        isActive: !row.isActive,
      });

      if (res?.status === 200 || res?.data?.status === 200) {
        showSuccessToast(
          res?.data?.message ||
          res?.data?.data?.message ||
          "status updated successfully",
        );
        queryClient.invalidateQueries({
        queryKey: ["get-all-employee", currentPage, limit, role],
      });
      } else {
        showErrorToast(
          res?.data?.message ||
          res?.data?.data?.message ||
          "Something went wrong",
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEmployeeLoading(false);
    }
  };

  const handleViewEmployee = async (id) => {
    try {
      if (!id) return;

      setIsViewLoading(true);

      const res = await getEmployeeById({ id });

      const apiData = res?.data?.data;

      setSingleEmployeeData(apiData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsViewLoading(false);
    }
  };

  return (
    <div className="sm:p-2">
      <h2 className="text-xl pl-4 flex items-center justify-start gap-2 md:text-2xl text-black font-bold mb-4 md:mb-8">
        <StethoscopeIcon className="text-purple-700" />
        Create Doctor Slot
      </h2>

      <div className="grid grid-cols-1 gap-8">
        <Card className=" rounded-xl bg-white  border-none ">
          <div className="w-full p-2 md:p-6 flex flex-col">
            <div className="w-full">
              <label htmlFor="selectDoctor" className="text-gray-700 font-bold">
                Select Doctor <span className="text-red-600">*</span>
              </label>
              <select
                className="border rounded my-2 p-2 w-full"
                name="selectDoctor"
                id="selectDoctor"
                onChange={(e) => {
                  const val = e.target.value;
                  const doctor = allDoctors?.find(
                    (item) => item.employeeId === val,
                  );
                  setCurrentDoctor(doctor);
                }}
              >
                <option value="">Select</option>

                {allDoctors?.map((item, idx) => (
                  <option value={item.employeeId} key={idx}>
                    {item.name} {item.employeeId}
                  </option>
                ))}
              </select>

              <FormRenderer
                fields={createDoctorFields}
                values={form}
                setValues={setForm}
              />
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              <label className="font-semibold text-gray-700 mb-2 block">
                OPD Timing
              </label>
              <div className="flex items-center justify-center w-full gap-6">
                {weekDays.map((day) => (
                  <div
                    key={day}
                    className="flex  flex-col items-center justify-center gap-2 text-sm bg-[#f1f5ff] w-full p-2 rounded "
                  >
                    <input
                      type="checkbox"
                      checked={days.includes(day)}
                      onChange={() => handleSelect(day)}
                      className="cursor-pointer"
                    />
                    <span className="items-center">{day}</span>
                  </div>
                ))}
              </div>

              <p className="text-xs text-gray-500 mt-2">
                Selected: {days.join(", ") || "None"}
              </p>
            </div>

            <div className="flex flex-row w-1/2 gap-2">
              <div className=" w-full lg:w-1/4 flex flex-col gap-2 mt-2">
                <div>
                  <label className="font-semibold text-gray-700">
                    Consultation Fee (₹)
                  </label>
                </div>
                <div className="relative mb-4">
                  <div>
                    <Input
                      type="number"
                      name="fee"
                      inputMode="numeric"
                      min={0}
                      value={fee}
                      onChange={handleFeeChange}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e" || e.key === "E") {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Consultation Fee (₹)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-3">
              <Button
                onClick={handleSubmit}
                className="flex items-center gap-2"
                disabled={
                  !isFormValid(createDoctorFields, form) || isSubmitloading
                }
                variant="admin.secondary"
              >
                {isSubmitloading ? (
                  <span className="flex items-center gap-2">
                    <Loader2 className="animate-spin" /> Please wait...
                  </span>
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </div>
        </Card>

        <Card className="rounded-xl border-none bg-white ">
          <div className="flex px-4 md:px-8 items-center w-full justify-between">
            <CardTitle className="text-md md:text-xl text-gray-600">
              All Doctors
            </CardTitle>
            <div className="flex flex-col pt-2 gap-1">
              <label className="font-semibold" htmlFor="limit">
                Select Limit
              </label>
              <select
                onChange={(e) => setLimit(e.target.value)}
                className="w-[150px] p-2 border bg-gradient-to-r from-blue-600 to-purple-700 text-white font-semibold rounded-lg"
                name=""
                id="limit"
              >
                <option className="bg-purple-800 text-white" value="5">
                  5
                </option>
                <option className="bg-purple-800 text-white" value="10">
                  10
                </option>
                <option className="bg-purple-800 text-white" value="20">
                  20
                </option>
                <option className="bg-purple-800 text-white" value="50">
                  50
                </option>
                <option className="bg-purple-800 text-white" value="100">
                  100
                </option>
              </select>
            </div>
          </div>
          <CardContent className="pl-4 text-[#081a3a] font-bold">
            {employeeLoading ? (
              <div className="flex justify-center py-10">
                <Loader />
              </div>
            ) : (
              <>
                <Table2
                  columns={employeeColumns}
                  data={employeeRows}
                  rowsPerPage={4}
                />

                <div className="w-full flex justify-center items-center py-4 gap-4">
                  <Button
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    disabled={currentPage === 1}
                    variant="admin.secondary"
                  >
                    prev
                  </Button>

                  <div>
                    Page {employee?.data?.data?.currentPage} of{" "}
                    {employee?.data?.data?.totalPages}
                  </div>

                  <Button
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={employee?.data?.data?.totalPages === currentPage}
                    variant="admin.secondary"
                  >
                    next
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>

      {singleEmployeeData && (
        <ViewEmployeeDataByID
          viewEmployeeData={singleEmployeeData}
          setViewEmployeeData={setSingleEmployeeData}
        />
      )}
    </div>
  );
};

export default CreateDoctor;
